import { POSITION } from '@voltmoney/types';
import { ACTION } from './types';
import { ROUTE } from '../../../../routes';
import { WIDGET, } from '@voltmoney/schema';
import { DigioKycStatus, ImportScriptSrc, } from '../../../../configs/constants';
import { getDigio, nextStepCredStepper, } from '../../../../configs/utils';
import { api } from '../../../../configs/api';
import SharedPropsService from '../../../../SharedPropsService';
import { APP_CONFIG, getAppHeader } from '../../../../configs/config';
import { Platform } from 'react-native';
import AsyncStorage from "@react-native-async-storage/async-storage";
let pollInterval;
let responseFromDigio;
let currentStepId;
export const AadharInitAction = async (action, _datastore, { instrumentTrack, navigate, setDatastore, importScript, network, digio, showPopup, removeWidgets, }) => {
    instrumentTrack("CO_BORROWER_PROCEED_WITH_DIGILOCKER_BUTTON_CLICKED");
    await setDatastore(ROUTE.CO_BORROWER_KYC_DIGIO_BASE, 'coBorrowerKycVerificationPage', {
        loading: true,
    });
    const user = await SharedPropsService.getUser();
    let applicationId = "";
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
        const userApplication = await network.get(`${api.borrowerApplication}${applicationId}`, { headers: await getAppHeader() });
        user.linkedApplications[0] = userApplication.data;
        await SharedPropsService.setUser(user);
    }
    else {
        applicationId = user.linkedApplications[0].applicationId;
    }
    let coBorrowerAccountId;
    const updatedApplicationResponse = await network.get(`${api.borrowerApplication}${applicationId}`, { headers: await getAppHeader() });
    if (await AsyncStorage.getItem("application_id") !== null) {
        coBorrowerAccountId = updatedApplicationResponse.data.currentCoBorrowerAccountId;
    }
    else {
        coBorrowerAccountId = user.linkedApplications[0].currentCoBorrowerAccountId;
    }
    const lenderId = user?.linkedApplications[0]?.lenderAccountId;
    if (Platform.OS === 'web') {
        importScript(ImportScriptSrc.DIGIO_SCRIPT, getDigio, async (digio_response) => {
            clearInterval(pollInterval);
            network
                .get(`${api.coBorrowerDigioKycCheckRequestStatusOnCallBackV2}${applicationId}/${coBorrowerAccountId}`, {
                headers: await getAppHeader(),
            })
                .then(async (response) => {
                if (response.status === 200 &&
                    response.data.stepResponseObject ===
                        DigioKycStatus.COMPLETED) {
                    await showPopup({
                        type: 'SUCCESS',
                        title: lenderId === 'Tata'
                            ? 'Aadhaar verified successfully'
                            : 'Aadhaar and PAN verified successfully',
                        ctaLabel: 'Continue',
                        primary: true,
                        ctaAction: {
                            routeId: ROUTE.CO_BORROWER_KYC_DIGIO_BASE,
                            type: ACTION.SUCCESS_VERIFICATION,
                            payload: {},
                        },
                    });
                }
            });
        }, async (response) => {
            clearInterval(pollInterval);
            network
                .get(`${api.coBorrowerDigioKycCheckRequestStatusOnCallBackV2}${applicationId}/${coBorrowerAccountId}`, {
                headers: await getAppHeader(),
            })
                .then(async (response) => {
                if (response.status === 200) {
                    if (response.data.stepResponseObject ===
                        DigioKycStatus.CREATED) {
                        await setDatastore(ROUTE.CO_BORROWER_KYC_DIGIO_BASE, 'coBorrowerKycVerificationPage', {
                            loading: false,
                        });
                    }
                    else if (response.data.stepResponseObject ===
                        DigioKycStatus.EXPIRED ||
                        response.data.stepResponseObject ===
                            DigioKycStatus.FAILED) {
                        console.log('Failure Digio_Response', response);
                        await showPopup({
                            type: 'FAILED',
                            title: 'Something went wrong',
                            // subTitle:
                            //     "Interest charges will be deducted automatically every month.",
                            ctaLabel: 'Try again',
                            primary: true,
                            ctaAction: {
                                routeId: ROUTE.CO_BORROWER_KYC_DIGIO_BASE,
                                type: ACTION.FAILED_VERIFICATION,
                                payload: {},
                            },
                        });
                    }
                }
            });
        }, "CO_BORROWER");
    }
    await network
        .get(`${api.coBorrowerDigioKycInitiateRequestV2}${applicationId}/${coBorrowerAccountId}`, {
        headers: await getAppHeader(),
    })
        .then(response => {
        if (response.status === 200) {
            if (response.data && response.data.stepResponseObject) {
                const requestId = response.data.stepResponseObject.requestId;
                const tokenId = response.data.stepResponseObject.tokenId;
                const identifier = response.data.stepResponseObject.identifier;
                if (Platform.OS !== 'web') {
                    navigate(ROUTE.DIGIO_MODAL_CO_BORROWER, {
                        requestId: requestId,
                        tokenId: tokenId,
                        identifier: identifier
                    });
                    removeWidgets(ROUTE.CO_BORROWER_KYC_DIGIO_BASE, [
                        { id: 'title', type: WIDGET.TEXT },
                        { id: 'spaceSubTitle', type: WIDGET.SPACE },
                        { id: 'subTitle', type: WIDGET.STACK },
                        {
                            id: 'spaceSecondarySubTitle',
                            type: WIDGET.SPACE,
                        },
                        { id: 'informationCard', type: WIDGET.STACK },
                        {
                            id: 'stackBottom',
                            type: WIDGET.STACK,
                            position: POSITION.ABSOLUTE_BOTTOM,
                        },
                    ]);
                }
                else {
                    console.log("custom res => ", response.data);
                    if (Platform.OS === 'web') {
                        // Take the Digio initialisation on the UI thread
                        setTimeout(() => {
                            digio.init();
                            digio.submit(requestId, identifier, tokenId);
                        });
                        //polling
                        pollInterval = setInterval(async () => {
                            network
                                .get(`${api.coBorrowerDigioKycCheckRequestStatusV2}${applicationId}/${coBorrowerAccountId}`, {
                                headers: await getAppHeader(),
                            }, async () => {
                                return;
                            }, {
                                disableDefault: true
                            })
                                .then(async (res) => {
                                if (res &&
                                    res.data &&
                                    res.data.stepResponseObject ===
                                        DigioKycStatus.COMPLETED) {
                                    await SharedPropsService.setUser(user);
                                    clearInterval(pollInterval);
                                    await showPopup({
                                        type: 'SUCCESS',
                                        title: lenderId === 'Tata'
                                            ? 'Aadhaar verified successfully'
                                            : 'Aadhaar and PAN verified successfully',
                                        // subTitle:
                                        //     "Interest charges will be deducted automatically every month.",
                                        ctaLabel: 'Continue',
                                        primary: true,
                                        ctaAction: {
                                            routeId: ROUTE.CO_BORROWER_KYC_DIGIO_BASE,
                                            type: ACTION.SUCCESS_VERIFICATION,
                                            payload: {},
                                        },
                                    });
                                    await setDatastore(ROUTE.CO_BORROWER_KYC_DIGIO_BASE, 'coBorrowerKycVerificationPage', {
                                        loading: false,
                                    });
                                }
                                else if ((res &&
                                    res.data &&
                                    res.data.stepResponseObject ===
                                        DigioKycStatus.EXPIRED) ||
                                    res.data.stepResponseObject ===
                                        DigioKycStatus.FAILED) {
                                    showPopup({
                                        type: 'FAILED',
                                        title: 'Something went wrong',
                                        // subTitle:
                                        //     "Interest charges will be deducted automatically every month.",
                                        ctaLabel: 'Try again',
                                        primary: true,
                                        ctaAction: {
                                            routeId: ROUTE.CO_BORROWER_KYC_DIGIO_BASE,
                                            type: ACTION.FAILED_VERIFICATION,
                                            payload: {},
                                        },
                                    });
                                    console.log('Verification Failed');
                                    clearInterval(pollInterval);
                                    await setDatastore(ROUTE.CO_BORROWER_KYC_DIGIO_BASE, 'coBorrowerKycVerificationPage', {
                                        loading: false,
                                    });
                                }
                            });
                        }, APP_CONFIG.POLLING_INTERVAL);
                    }
                }
            }
        }
    })
        .catch(error => {
        console.log(error);
    });
};
export const digioCallback = async (action, datastore, { network, showPopup, removeWidgets }) => {
    responseFromDigio = action.payload;
    const type = action.payload.type;
    const error = action.payload.error;
    const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
    const applicationId = await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") :
        userContextResponse.data.linkedApplications[0].applicationId;
    const coBorrowerAccountId = userContextResponse.data.linkedApplications[0]
        .currentCoBorrowerAccountId;
    await network
        .get(`${api.coBorrowerDigioKycCheckRequestStatusOnCallBackV2}${applicationId}/${coBorrowerAccountId}`, {
        headers: await getAppHeader(),
    })
        .then(async (response) => {
    });
};
export const GoBackAction = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.KYC_STEPPER);
};
export const failedVerification = async (action, _datastore, { goBack, hidePopup }) => {
};
export const successVerification = async (action, _datastore, { goBack, navigateWithClear }) => {
    const payLoadCurrentStepId = action.payload.value;
    let routeObj;
    if (currentStepId) {
        routeObj = await nextStepCredStepper(payLoadCurrentStepId ? payLoadCurrentStepId : currentStepId);
    }
    else {
        routeObj = await nextStepCredStepper();
    }
    await navigateWithClear(routeObj.routeId, routeObj.params);
};
export const digilockerAction = async (action, _datastore, { instrumentTrack, navigate }) => {
    instrumentTrack("CO_BORROWER_UPLOAD_KYC_DOCUMENT_BUTTON_CLICKED");
    await navigate(ROUTE.CO_BORROWER_KYC_DOCUMENTS_UPLOAD_BASE, {});
};
export const BajajAadharInitCoBorrowerAction = async (action, _datastore, { instrumentTrack, setDatastore, network, openNewTab, showPopup, navigateWithClear, navigate, removeWidgets }) => {
    console.warn("*** BajajAadharInitAction action triggered *** : ", action);
    instrumentTrack("PROCEED_WITH_DIGILOCKER_BUTTON_CLICKED");
    await setDatastore(ROUTE.CO_BORROWER_KYC_DIGIO_BASE, 'coBorrowerKycVerificationPage', {
        loading: true,
    });
    const user = await SharedPropsService.getUser();
    let applicationId = "";
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
        const userApplication = await network.get(`${api.borrowerApplication}${applicationId}`, { headers: await getAppHeader() });
        user.linkedApplications[0] = userApplication.data;
        await SharedPropsService.setUser(user);
    }
    else {
        applicationId = user.linkedApplications[0].applicationId;
    }
    let coBorrowerAccountId;
    const updatedApplicationResponse = await network.get(`${api.borrowerApplication}${applicationId}`, { headers: await getAppHeader() });
    if (await AsyncStorage.getItem("application_id") !== null) {
        coBorrowerAccountId = updatedApplicationResponse.data.currentCoBorrowerAccountId;
    }
    else {
        coBorrowerAccountId = user.linkedApplications[0].currentCoBorrowerAccountId;
    }
    let bajajDigioWindowObj;
    let pollInterval;
    // Digio Kyc Mandate
    const bajajDigioInitResponse = await network.get(`${api.bajajDigioCoBorrowerInit}${applicationId}/${coBorrowerAccountId}`, {
        headers: await getAppHeader()
    });
    if (bajajDigioInitResponse && bajajDigioInitResponse.status === 200) {
        const requestUrl = bajajDigioInitResponse?.data?.stepResponseObject?.requestUrl;
        const transactionId = bajajDigioInitResponse?.data?.stepResponseObject?.transactionId;
        //handle for web
        if (Platform.OS === 'web' && requestUrl) {
            bajajDigioWindowObj = window.open(requestUrl, 'PopupWindowName', 'width=600,height=400');
        }
        else if (Platform.OS !== 'web') {
            navigate(ROUTE.DIGIO_MODAL_CO_BORROWER, {
                showKycPod: true,
                webUrl: requestUrl
            });
            removeWidgets(ROUTE.CO_BORROWER_KYC_DIGIO_BASE, [
                { id: 'title', type: WIDGET.TEXT },
                { id: 'spaceSubTitle', type: WIDGET.SPACE },
                { id: 'subTitle', type: WIDGET.STACK },
                {
                    id: 'spaceSecondarySubTitle',
                    type: WIDGET.SPACE,
                },
                { id: 'informationCard', type: WIDGET.STACK },
                {
                    id: 'stackBottom',
                    type: WIDGET.STACK,
                    position: POSITION.ABSOLUTE_BOTTOM,
                },
            ]);
        }
        const checkDigioStatus = async () => {
            if (Platform.OS !== "web") {
                const digioStatusResponse = await network.get(`${api.bajajDigioCoBorrowerDeepCheckStatus}${applicationId}/${coBorrowerAccountId}`, {
                    headers: await getAppHeader()
                });
                if (digioStatusResponse?.status === 200) {
                    const digioStatus = digioStatusResponse?.data?.stepResponseObject;
                    if (digioStatus === DigioKycStatus.COMPLETED) {
                        currentStepId = digioStatusResponse?.data?.updatedApplicationObj?.currentStepId;
                        clearInterval(pollInterval);
                        navigateWithClear(ROUTE.CO_BORROWER_KYC_DIGIO_BASE, {
                            successModal: true,
                            successTitle: 'KYC done successfully',
                            successSubTitle: ' ',
                            successButtonTitle: 'Continue',
                            failedModal: false
                        });
                    }
                    else if (digioStatus === DigioKycStatus.EXPIRED
                        || digioStatus === DigioKycStatus.FAILED) {
                        clearInterval(pollInterval);
                        navigateWithClear(ROUTE.CO_BORROWER_KYC_DIGIO_BASE, {
                            failedModal: true,
                            failedTitle: 'KYC verification failed',
                            failedSubTitle: 'Please try again in sometime',
                            failedButtonTitle: 'Try again',
                            successModal: false
                        });
                    }
                }
                else {
                    if (digioStatusResponse.response.data.voltErrorCode === "DIGIO_PAN_MISMATCH") {
                        clearInterval(pollInterval);
                        navigateWithClear(ROUTE.CO_BORROWER_KYC_DIGIO_BASE, {
                            failedModal: true,
                            failedTitle: 'PAN mismatch',
                            failedSubTitle: digioStatusResponse.response.data.message,
                            failedButtonTitle: 'Try again',
                            successModal: false
                        });
                    }
                    else if (digioStatusResponse.response.data.voltErrorCode === "ADDRESS_MISMATCH") {
                        clearInterval(pollInterval);
                        navigateWithClear(ROUTE.CO_BORROWER_KYC_DIGIO_BASE, {
                            failedModal: true,
                            failedTitle: 'Address mismatch',
                            failedSubTitle: digioStatusResponse.response.data.message,
                            failedButtonTitle: 'Try again',
                            successModal: false
                        });
                    }
                }
            }
            else if (Platform.OS === "web") {
                const digioStatusResponse = await network.get(`${api.bajajDigioCoBorrowerDeepCheckStatus}${applicationId}/${coBorrowerAccountId}`, {
                    headers: await getAppHeader()
                });
                if (digioStatusResponse?.status === 200) {
                    const digioStatus = digioStatusResponse?.data?.stepResponseObject;
                    if (bajajDigioWindowObj?.closed && (digioStatus !== DigioKycStatus.COMPLETED && digioStatus !== DigioKycStatus.FAILED && digioStatus !== DigioKycStatus.EXPIRED)) {
                        bajajDigioWindowObj?.close();
                        clearInterval(pollInterval);
                        await setDatastore(ROUTE.CO_BORROWER_KYC_DIGIO_BASE, "coBorrowerKycVerificationPage", {
                            failedModal: true,
                            failedTitle: 'KYC Verification cancelled',
                            failedSubTitle: 'KYC verification is required for the completion of your loan application',
                            failedButtonTitle: 'Try again.',
                            successModal: false,
                            counter: Math.random()
                        });
                    }
                    else if (digioStatus === DigioKycStatus.COMPLETED) {
                        bajajDigioWindowObj?.close();
                        currentStepId = digioStatusResponse?.data?.updatedApplicationObj?.currentStepId;
                        clearInterval(pollInterval);
                        await setDatastore(ROUTE.CO_BORROWER_KYC_DIGIO_BASE, "coBorrowerKycVerificationPage", {
                            failedModal: false,
                            successTitle: 'KYC verification successful',
                            successSubTitle: "KYC has been verified successfully",
                            successButtonTitle: 'Continue to next step',
                            successModal: true
                        });
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                            loading: false,
                        });
                    }
                    else if (digioStatus === DigioKycStatus.EXPIRED
                        || digioStatus === DigioKycStatus.FAILED) {
                        bajajDigioWindowObj?.close();
                        clearInterval(pollInterval);
                        await setDatastore(ROUTE.CO_BORROWER_KYC_DIGIO_BASE, "coBorrowerKycVerificationPage", {
                            failedModal: true,
                            failedTitle: 'Something went wrong!',
                            failedSubTitle: '',
                            failedButtonTitle: 'Try again.',
                            successModal: false,
                            counter: Math.random()
                        });
                    }
                }
                else {
                    if (digioStatusResponse?.response?.data?.voltErrorCode === "DIGIO_PAN_MISMATCH") {
                        bajajDigioWindowObj?.close();
                        clearInterval(pollInterval);
                        await setDatastore(ROUTE.CO_BORROWER_KYC_DIGIO_BASE, "coBorrowerKycVerificationPage", {
                            failedModal: true,
                            failedTitle: 'PAN mismatch',
                            failedSubTitle: digioStatusResponse?.response?.data?.message,
                            failedButtonTitle: 'Try again.',
                            successModal: false,
                            counter: Math.random()
                        });
                    }
                    else if (digioStatusResponse?.response?.data?.voltErrorCode === "ADDRESS_MISMATCH") {
                        bajajDigioWindowObj?.close();
                        clearInterval(pollInterval);
                        await setDatastore(ROUTE.CO_BORROWER_KYC_DIGIO_BASE, "coBorrowerKycVerificationPage", {
                            failedModal: true,
                            failedTitle: 'Address mismatch',
                            failedSubTitle: digioStatusResponse?.response?.data?.message,
                            failedButtonTitle: 'Try again.',
                            successModal: false,
                            counter: Math.random()
                        });
                    }
                }
            }
        };
        pollInterval = setInterval(() => {
            checkDigioStatus();
        }, 2000);
    }
    await setDatastore(ROUTE.CO_BORROWER_KYC_DIGIO_BASE, 'coBorrowerKycVerificationPage', {
        loading: false,
    });
};
export const doKYCLaterAction = async (action, _datastore, { instrumentTrack, navigate }) => {
    await navigate(ROUTE.CO_BORROWER_SUMMARY);
};
